import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import './styles/App.css';

// Import pages
import Home from './pages/Home';
import ProductOutline from './pages/ProductOutline';
import ProductWrite from './pages/ProductWrite';
import ProductIdeate from './pages/ProductIdeate';
import Pricing from './pages/Pricing';
import About from './pages/About';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Features from './pages/Features';
import QA from './pages/QA';
import Download from './pages/Download';
import Brand from './pages/Brand';
import BuyScripts from './pages/BuyScripts';
import Switch from './pages/Switch';
import Guides from './pages/Guides';
import Mobile from './pages/Mobile';
import NotFound from './pages/404';

// Import components
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Import context
import { WaitlistProvider } from './context/WaitlistContext';

function AppContent() {
  const location = useLocation();
  const normalizedPath = location.pathname.endsWith('/') && location.pathname !== '/'
    ? location.pathname.slice(0, -1)
    : location.pathname;
  const knownRoutes = new Set([
    '/',
    '/product/outline',
    '/product/write',
    '/product/ideate',
    '/pricing',
    '/about',
    '/contact',
    '/terms',
    '/privacy',
    '/product/features',
    '/features',
    '/qa',
    '/download',
    '/brand',
    '/buy-scripts',
    '/switch',
    '/guides',
    '/mobile',
  ]);
  const isFeaturesPage = location.pathname === '/product/features';
  const isQAPage = location.pathname === '/qa';
  const isDownloadPage = location.pathname === '/download';
  const isBrandPage = location.pathname === '/brand';
  const isBuyScriptsPage = location.pathname === '/buy-scripts';
  const isSwitchPage = location.pathname === '/switch';
  const isGuidesPage = location.pathname === '/guides';
  const isNotFoundPage = normalizedPath === '/404' || !knownRoutes.has(normalizedPath);

  return (
        <div className="App">
          {!isGuidesPage && <Navigation />}
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/product/outline" element={<ProductOutline />} />
              <Route path="/product/write" element={<ProductWrite />} />
              <Route path="/product/ideate" element={<ProductIdeate />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/product/features" element={<Features />} />
          <Route path="/features" element={<Navigate to="/product/features" replace />} />
          <Route path="/qa" element={<QA />} />
          <Route path="/download" element={<Download />} />
          <Route path="/brand" element={<Brand />} />
              <Route path="/buy-scripts" element={<BuyScripts />} />
              <Route path="/switch" element={<Switch />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/mobile" element={<Mobile />} />
              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
      {!isFeaturesPage && !isQAPage && !isDownloadPage && !isBrandPage && !isBuyScriptsPage && !isSwitchPage && !isGuidesPage && !isNotFoundPage && <Footer />}
        </div>
  );
}

function App() {
  return (
    <Router>
      <WaitlistProvider>
        <ScrollToTop />
        <AppContent />
      </WaitlistProvider>
    </Router>
  );
}

export default App;


